// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Sbrw","title":"styles_title__2UeGY"};